import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraContractualArrangement } from '../../models/doraContractualArrangement.ts';

interface ArrangementState {
  arrangements: DoraContractualArrangement[];
  loading: boolean;
  error: string | null;
}

const initialState: ArrangementState = {
  arrangements: [],
  loading: false,
  error: null,
};

const contractualArrangementSlice = createSlice({
  name: 'doraContractualArrangement',
  initialState,
  reducers: {
    setArrangements(state, action: PayloadAction<DoraContractualArrangement[]>) {
      state.arrangements = action.payload;
    },
    addArrangement(state, action: PayloadAction<DoraContractualArrangement>) {
      state.arrangements.push(action.payload);
    },
    updateArrangement(state, action: PayloadAction<DoraContractualArrangement>) {
      const idx = state.arrangements.findIndex(a => a.id === action.payload.id);
      if (idx !== -1) state.arrangements[idx] = action.payload;
    },
    removeArrangement(state, action: PayloadAction<number>) {
      state.arrangements = state.arrangements.filter(a => a.id !== action.payload);
    },
    setArrangementLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setArrangementError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

export const {
  setArrangements,
  addArrangement,
  updateArrangement,
  removeArrangement,
  setArrangementLoading,
  setArrangementError,
} = contractualArrangementSlice.actions;

export const selectArrangements = (state: RootState) => state.doraContractualArrangement.arrangements;
export const selectArrangementLoading = (state: RootState) => state.doraContractualArrangement.loading;
export const selectArrangementError = (state: RootState) => state.doraContractualArrangement.error;

export default contractualArrangementSlice.reducer;
